export class CalendarEnvironment {
  public static getName = () => 'benzinga-calendar';
  public static getEnvironment = (env: Record<string, string>) => ({
    dataUrl: new URL(env.dataUrl ?? 'https://api.benzinga.com/api/'),
    eventsToken: env.eventsToken ?? '',
    secDataUrl: env.secDataUrl ? new URL(env.secDataUrl) : undefined,
    secToken: env.secToken ?? '',
    token: env.token ?? '',
    url: new URL(env.url ?? 'https://www.benzinga.com/'),
  });
}
